import { RouterGuard } from '@/services/router/types';

/**
 * Handle access based on role based permissions.
 */
export const accessGuard: RouterGuard = function accessGuard(to, from, next) {
  if (!this.routeHasAccess(to)) {
    next({ name: 'error', query: { code: 'AccessDenied' } });
  }
  else {
    next();
  }
};
